import React from "react";
import { StyleSheet, Text, TextInput, View, Platform } from "react-native";
import { STYLES } from "../assets/styles";
import { lightenColor } from "../common";
import CustomIcon from "./CustomIcon";

function CustomInput({
  leftIcon = {},
  rightIcon = {},
  value,
  label,
  iconStyle = {},
  inputStyle = {},
  onChangeText = () => {},
  placeholder,
  transparent,
  style = {},
  secureTextEntry = false,
  keyboardType = "default",
  color = STYLES.colors.white,
  error = false,
  required = false,
  requiredText = "",
  containerStyle = {},
}) {
  return (
    <View style={[{ marginVertical: 5 }, containerStyle]}>
      {label ? (
        <Text style={{ fontSize: STYLES.fontSizes.mini * 1.2 }}>{label}</Text>
      ) : null}
      <View
        style={{
          flexDirection: "row",
          backgroundColor: transparent ? "transparent" : STYLES.colors.white,
          borderBottomWidth: 1,
          borderBottomColor: color,
          alignItems: "center",
          ...style,
        }}
      >
        <CustomIcon
          type={leftIcon.type}
          name={leftIcon.name}
          onPress={leftIcon.onPress}
          style={{ ...styles.iconStyle, color: color, ...iconStyle }}
        />
        <TextInput
          value={value}
          secureTextEntry={secureTextEntry}
          keyboardType={keyboardType}
          onChangeText={onChangeText}
          style={[
            styles.inputStyle,
            { color: color },
            inputStyle,
            Platform.OS === "web" ? { outline: 0 } : {},
          ]}
          placeholder={placeholder}
          autoCapitalize="none"
          placeholderTextColor={lightenColor(color, 90)}
        />
        <CustomIcon
          type={rightIcon.type}
          name={rightIcon.name}
          onPress={rightIcon.onPress}
          style={{ ...styles.iconStyle, color: color, ...iconStyle }}
        />
      </View>
      {required ? (
        <Text
          style={{
            fontSize: STYLES.fontSizes.mini,
            color: error ? STYLES.colors.tomato : color,
          }}
        >
          * {requiredText}
        </Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  iconStyle: {
    fontSize: STYLES.fontSizes.medium,
  },
  inputStyle: {
    flex: 1,
    fontSize: STYLES.fontSizes.medium,
    paddingVertical: 0,
  },
});

export default CustomInput;
